import React, { useEffect, useState } from 'react';
import BarraPrincipal from '../Modulos/BarraPrincipal';
import Swal from 'sweetalert2';
import axios from '../utils/axiosConfig';
import './Css/trafico.css';
import './Css/traficoOcultoResponsive.css';
import PreloaderHistorico from '../components/preloaders/preloader-historico';
import { formatMinutesToHoursAndMinutes, formattedGlobalDate } from '../utils/formattedDates';
import MenuContratos from '../components/menuContratos/menuContratos';
import BaseModalXXL from '../components/modals/baseModalXXL';
import ReporteContrato from '../Modulos/ReporteContrato';
import ReporteDian from '../Modulos/ReporteDian';
import ModalBaseLg from '../components/modals/modal-base-lg';
import BaseModalAuto from '../components/modals/baseModalAuto';
import PrintComponent from '../components/printComponent/PrintComponent';
import ModalReporteServicio2 from '../components/modals/menuContratos/modalReporteServicio';
import ModalComprobanteValitronics from '../components/modals/menuContratos/modalComprobanteValitronics';
import VideoGallery from '../componentes/videoGallery';
import ModalGaleria from '../components/modals/menuContratos/modalGaleria';
import ModalAsignacion from '../components/modals/menuContratos/modalAsignacion';
import ModalReporteServicio from '../components/modals/modalReporteServicio';
import FormStaticsMapsRecorrido from '../components/formsSolicitudes/formStaticsMapsRecorrido';
import ModalReporteConsolidadoAjustado from '../components/modals/modalReporteConsolidadoAjustado';
import RSeguimientoServicio from '../components/modals/modalRSeguimientoServicio';
import FormReporteServicio from '../components/formsSolicitudes/formReporteServicio';
import BaseModalCreateSolcitud from '../components/modals/baseModal';
import FormUpdateContratoProyecto from '../components/formsSolicitudes/formUpdateContratoProyectos';
import FormUpdateContrato from '../components/formsSolicitudes/formUpdateContrato';
import ReporteServicio from '../Modulos/Reporteservicio';
import ModalFoto from '../components/modals/menuContratos/modalFoto';
import ModalVideo from '../components/modals/menuContratos/modalVideo';
import EnVivoPanel from '../components/enVivo/EnVivoPanel';
import BaseModalAuto2 from '../components/modals/BaseModalAuto2';
import {
    preferredLocalToUTCDateTime,
    utcToPreferredLocalDateTime,
} from '../utils/timezoneDateConversion';

const TraficoOculto = () => {
    const [equipos, setEquipos] = useState([]);
    const [filteredEquipos, setFilteredEquipos] = useState([]);
    const [isTrafficLoading, setIsTrafficLoading] = useState(true);

    const [ultPunto, setUltPunto] = useState(null);
    const [contractR, setContractR] = useState(null);

    const [showEmpresa, setShowEmpresa] = useState(true);
    const [showDispositivo, setShowDispositivo] = useState(true);
    const [showBateria, setShowBateria] = useState(true);
    const [showPlaca, setShowPlaca] = useState(true);
    const [showRuta, setShowRuta] = useState(true);
    const [showEstado, setShowEstado] = useState(true);
    const [showUbicacionGps, setShowUbicacionGps] = useState(true);
    const [showUbicacionTrafico, setShowUbicacionTrafico] = useState(true);
    const [showMoving, setShowMoving] = useState(true);
    const [showLocked, setShowLocked] = useState(true);
    const [showNoGps, setShowNoGps] = useState(true);
    const [showDesvio, setShowDesvio] = useState(true);
    const [showBack, setShowBack] = useState(true);
    const [showSeguro, setShowSeguro] = useState(true);
    const [showValitronics, setShowValitronics] = useState(true);
    const [showTiempo, setShowTiempo] = useState(true);

    const [modalLoading, setModalLoading] = useState(false);

    const [sortBy, setSortBy] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc');

    const project = localStorage.getItem('project');

    const [dropdownOpenMultimedia, setDropdownOpenMultimedia] = useState(false);
    const [dropdownOpenReportes, setDropdownOpenReportes] = useState(false);
    const [dropdownOpenOpciones, setDropdownOpenOpciones] = useState(false);
    const [dropdownOpenValitronics, setDropdownOpenValitronics] = useState(false);

    const [infocontratoContainer, setInfocontratoContainer] = useState(null);
    const [isDialogOpenModalGaleria, setIsDialogOpenModalGaleria] = useState(false);
    const [isDialogOpenModalComprobanteValitronics, setIsDialogOpenModalComprobanteValitronics] = useState(false);
    const [isDialogOpenEditContratoProject, setIsDialogOpenEditContratoProject] = useState(false);
    const [isDialogOpenRServicioAjustado, setIsDialogOpenRServicioAjustado] = useState(false);
    const [isDialogOpenModalVideoGaleria, setIsDialogOpenModalVideoGaleria] = useState(false);

    const [dataGlobal, setDataGlobal] = useState(null);
    const [infoUpdateContrato, setInfoUpdateContrato] = useState([]);
    const [listRutas, setListRutas] = useState([]);
    const [listEventos, setListEventos] = useState([]);
    const [listComprobantes, setListComprobantes] = useState([]);
    const [modalIsLoading, setModalIsLoading] = useState(false);

    const [bitOpenTracking, setBitOpenTracking] = useState(false);
    const [bitInsertTracking, setBitInsertTracking] = useState(false);
    const [bitEditTracking, setBitEditTracking] = useState(false);
    const [bitDeleteTracking, setBitDeleteTracking] = useState(false);

    const [bitOpenUpdateContract, setBitOpenUpdateContract] = useState(false);
    const [bitInsertUpdateContract, setBitInsertUpdateContract] = useState(false);
    const [bitEditUpdateContract, setBitEditUpdateContract] = useState(false);
    const [bitDeleteUpdateContract, setBitDeleteUpdateContract] = useState(false);

    const [rutaseleccionada, setRutaseleccionada] = useState(-1);
    const [eventoseleccionado, setEventoseleccionado] = useState(-1);
    const [isDialogOpenAsignacion, setIsDialogOpenAsignacion] = useState(false);
    const [isDialogOpenEditSolicitud, setIsDialogOpenEditSolicitud] = useState(false);

    const [modalAbierto2, setModalAbierto2] = useState(false);
    const [modalEnVivoOpen, setModalEnVivoOpen] = useState(false);
    const [contratoEnVivo, setContratoEnVivo] = useState(null);
    const [infocontrato2, setInfocontrato2] = useState(null);

    const [infocontrato, setInfocontrato] = useState(null);
    const [mostrarReporteConsolidado, setMostrarReporteConsolidado] = useState(false);

    const [modalAbierto, setModalAbierto] = useState(false);
    const [contratoDian, setContratoDian] = useState(null);

    const [bitOpenUploadPhoto, setBitOpenUploadPhoto] = useState(false);
    const [bitInsertUploadPhoto, setBitInsertUploadPhoto] = useState(false);
    const [bitEditUploadPhoto, setBitEditUploadPhoto] = useState(false);
    const [bitDeleteUploadPhoto, setBitDeleteUploadPhoto] = useState(false);

    const [bitOpenUploadVideo, setBitOpenUploadVideo] = useState(false);
    const [bitInsertUploadVideo, setBitInsertUploadVideo] = useState(false);
    const [bitEditUploadVideo, setBitEditUploadVideo] = useState(false);
    const [bitDeleteUploadVideo, setBitDeleteUploadVideo] = useState(false);
    const [isDialogOpenModalVideo, setIsDialogOpenModalVideo] = useState(false);

    const [bitOpenActualizarContrato, setBitOpenActualizarContrato] = useState(false);
    const [bitInsertUActualizarContrato, setBitInsertUActualizarContrato] = useState(false);
    const [bitEditUActualizarContrato, setBitEditUActualizarContrato] = useState(false);
    const [bitDeleteUActualizarContrato, setBitDeleteUActualizarContrato] = useState(false);

    const [username, setUsername] = useState(null);
    const [placa, setPlaca] = useState(null);
    const [device, setDevice] = useState(null);
    const [FKLokProyecto, setFKLokProyecto] = useState(null);
    const [FKICEmpresa, setFKICEmpresa] = useState(null);
    const [isDialogOpenModalFoto, setIsDialogOpenModalFoto] = useState(false);

    const [bitOpenMonitoreo, setBitOpenMonitoreo] = useState(false);
    const [bitInsertMonitoreo, setBitInsertMonitoreo] = useState(false);
    const [bitEditMonitoreo, setBitEditMonitoreo] = useState(false);
    const [bitDeleteMonitoreo, setBitDeleteMonitoreo] = useState(false);

    const [isDialogOpenModalListaCheck, setIsDialogOpenModalListaCheck] = useState(false);

    const [bitOpenUpdateContrato, setBitOpenUpdateContrato] = useState(false);
    const [bitInsertUpdateContrato, setBitInsertUpdateContrato] = useState(false);
    const [bitEditUpdateContrato, setBitEditUpdateContrato] = useState(false);
    const [bitDeleteUpdateContrato, setBitDeleteUpdateContrato] = useState(false);
    const [contratoseleccionado, setContratoseleccionado] = useState(null);
    const [isDialogOpenRSeguimientoServicio, setIsDialogOpenRSeguimientoServicio] = useState(false);
    const [infocontratoAjustado, setInfocontratoAjustado] = useState(null);
    const [isDialogOpenModalReporteServicio, setIsDialogOpenModalReporteServicio] = useState(false);

    const [onHide, setOnHide] = useState(false);

    const handleUltPunto = (newValue) => {
        setUltPunto(newValue);
    };

    const handleUltRecorrido = (newValue) => {
        setContractR(newValue);
    };

    const cerrarModal2 = () => setModalAbierto2(false);
    const onCloseReporteServicio = () => setIsDialogOpenRSeguimientoServicio(false);
    const onCloseEditContract = async () => {
        if (project == 1) {
            setIsDialogOpenEditSolicitud(false);
            await listarEquipos();
        } else {
            setIsDialogOpenEditContratoProject(false);
            await listarEquipos();
        }
    };

    const onCloseReporteServicioAjustado = () => {
        setIsDialogOpenRServicioAjustado(false);
    };

    const onCloseModalReporteServicio = () => {
        setMostrarReporteConsolidado(false);
        setIsDialogOpenModalReporteServicio(false);
        setUltPunto(-1);
        setContractR(-1);
    };

    const onCloseModalFoto = () => setIsDialogOpenModalFoto(false);
    const onCloseModalVideo = () => setIsDialogOpenModalVideo(false);
    const onCloseModalComprobanteValitronics = () => setIsDialogOpenModalComprobanteValitronics(false);
    const onCloseModalListaCheck = () => setIsDialogOpenModalListaCheck(false);

    const listarEquipos = async () => {
        setIsTrafficLoading(true);
        try {
            const response = await axios.get(
                process.env.REACT_APP_SERVER + '/operaciones/getcontratostraficooculto'
            );

            const raw = response.data.data || [];
            const withExpanded = raw.map((item) => {
                const stored = localStorage.getItem(`contrato_${item.ContractID}_expanded`);
                return stored !== null
                    ? { ...item, expanded: JSON.parse(stored) }
                    : { ...item, expanded: false };
            });
            console.log("Equipos obtenidos y con estado expandido: ", raw, withExpanded);
            setEquipos(withExpanded);
            setFilteredEquipos(withExpanded);

            if (response.data.success === false) {
                window.location = '/';
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo obtener la lista de equipos',
            });
            console.log(error);
        } finally {
            setIsTrafficLoading(false);
        }
    };

    const EditarEvento = (evento) => {
        setEventoseleccionado(evento);
    };

    const handleSubmitAndOpenReporteAjustado = () => {
        const infocontratoCopy = infocontrato ? { ...infocontrato } : null;
        setIsDialogOpenRServicioAjustado(false);
        if (infocontratoCopy) OpenModalReporteServicio(infocontratoCopy);
    };

    // MENÚ
    const handleAllStatesDropdowns = () => {
        setDropdownOpenMultimedia(false);
        setDropdownOpenReportes(false);
        setDropdownOpenOpciones(false);
        setDropdownOpenValitronics(false);
    };

    const OpenGalleryPhoto = (data) => {
        setDataGlobal(data);
        setContratoseleccionado(data?.ContractID ?? null);
        setInfocontratoContainer(data?.ContainerNum ?? null);
        setIsDialogOpenModalGaleria(true);
    };

    const OpenGalleryVideo = (data) => {
        setContratoseleccionado(data?.ContractID ?? null);
    };

    const OpenValitronics = async () => {
        if (dataGlobal) {
            OpenComprobante(dataGlobal);
        }
    };

    const OpenMonitoreo = async () => {
        if (dataGlobal) {
            showModalOpenResporteServicio(dataGlobal);
        }
    };

    const showModalTrayecto = async () => {
        if (dataGlobal) {
            EditContrato(dataGlobal);
        }
    };

    const OpenReporteServicio = (data) => {
        setInfocontrato(data);
        setMostrarReporteConsolidado(true);
    };

    const ListarComprobantes = async (contrato) => {
        try {
            const token = localStorage.getItem('tkn');
            if (!token) {
                window.location = '/';
                return;
            }

            const { data: resp } = await axios.post(
                `${process.env.REACT_APP_SERVER}/operaciones/getcomprobantevalitronics`,
                { contrato },
                {
                    headers: { Authorization: `Bearer ${token}` },
                    withCredentials: true,
                }
            );

            if (resp?.success === false) {
                window.location = '/';
                return;
            }

            setListComprobantes(Array.isArray(resp?.data) ? resp.data : []);
        } catch (err) {
            console.error('Error al listar comprobantes:', err);
            setListComprobantes([]);
        }
    };

    const OpenVideos = async () => {
        OpenGalleryVideo(dataGlobal);
        setIsDialogOpenModalVideoGaleria(true);
    };

    const OpenComprobante = (data) => {
        setContratoseleccionado(data?.ContractID ?? null);
        setIsDialogOpenModalComprobanteValitronics(true);
        ListarComprobantes(data?.ContractID);
    };

    const OpenImages = async () => {
        OpenGalleryPhoto(dataGlobal);
        setIsDialogOpenModalGaleria(true);
    };

    const obtenerYEstablecerDatosProyecto = async (contrato) => {
        try {
            const token = localStorage.getItem('tkn');
            if (!token) {
                window.location = '/';
                return;
            }

            const { data: resp } = await axios.post(
                `${process.env.REACT_APP_SERVER}/contratos/getinfocontratoproyecto`,
                { contrato },
                {
                    headers: { Authorization: `Bearer ${token}` },
                    withCredentials: true,
                }
            );

            if (resp?.success === false) {
                window.location = '/';
                return;
            }

            const info = resp?.data?.data ?? resp?.data ?? null;

            console.log("Info para setear los estados (Proyecto): ", info);

            setInfoUpdateContrato(info);
            setContratoseleccionado(contrato);

            if (project == 1) {
                setIsDialogOpenEditSolicitud(true);
            } else {
                setIsDialogOpenEditContratoProject(true);
            }
        } catch (err) {
            console.error('Error obtenerYEstablecerDatosProyecto:', err);
        }
    };

    const obtenerYEstablecerDatos = async (contrato) => {
        try {
            const token = localStorage.getItem('tkn');
            if (!token) {
                window.location = '/';
                return;
            }
            console.log("Obteniendo datos para contrato: ", contrato);
            const { data: resp } = await axios.post(
                `${process.env.REACT_APP_SERVER}/contratos/getinfocontrato`,
                { contrato },
                {
                    headers: { Authorization: `Bearer ${token}` },
                    withCredentials: true,
                }
            );

            if (resp?.success === false) {
                window.location = '/';
                return;
            }
            console.log("Info para setear los estados de Contrato: ", resp);

            const info = resp?.data?.data ?? resp?.data ?? null;


            setInfoUpdateContrato(info);
            setContratoseleccionado(contrato);

            if (project == 1) {
                setIsDialogOpenEditSolicitud(true);
            } else {
                setIsDialogOpenEditContratoProject(true);
            }
        } catch (err) {
            console.error('Error obtenerYEstablecerDatos:', err);
        }
    };

    const showEditContract = async (data) => {
        const payload = { pagina: '19' };

        try {
            const { data: resp } = await axios.post(
                `${process.env.REACT_APP_SERVER}/usuarios/getconfiguracionpagina`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                    withCredentials: true,
                }
            );

            if (resp?.success === false) {
                window.location = '/';
                return;
            }

            const permisos = resp?.data?.[0];
            if (!permisos) return;

            setBitOpenActualizarContrato(!!permisos.bitOpen);
            setBitInsertUActualizarContrato(!!permisos.bitInsert);
            setBitEditUActualizarContrato(!!permisos.bitEdit);
            setBitDeleteUActualizarContrato(!!permisos.bitDelete);

            if (permisos.bitOpen) {
                if (project === '1' || project === 1) {
                    obtenerYEstablecerDatos(data?.ContractID);
                } else {
                    obtenerYEstablecerDatosProyecto(data?.ContractID);
                }
            } else {
                await Swal.fire({
                    title: 'Información',
                    text: 'No tiene los permisos necesarios para acceder a esta opción',
                    icon: 'info',
                    timer: 3000,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    didOpen: () => Swal.showLoading(),
                });
            }
        } catch (error) {
            console.error('Error al listar bit permisos:', error);
        }
    };

    const ActualizarContratoDevice = async (data) => {
        const token = localStorage.getItem('tkn');
        if (!token) {
            window.location = '/';
            return;
        }

        try {
            const { data: resp } = await axios.post(
                `${process.env.REACT_APP_SERVER}/usuarios/getconfiguracionpagina`,
                { pagina: '17' },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    withCredentials: true,
                }
            );

            if (resp?.success === false) {
                window.location = '/';
                return;
            }

            const permisos = resp?.data?.[0];
            if (!permisos) {
                $('#danger-alert')
                    .fadeTo(2000, 500)
                    .slideUp(500, function () {
                        $('#danger-alert').slideUp(2000);
                    });
                return;
            }

            setBitOpenUpdateContrato(!!permisos.bitOpen);
            setBitInsertUpdateContrato(!!permisos.bitInsert);
            setBitEditUpdateContrato(!!permisos.bitEdit);
            setBitDeleteUpdateContrato(!!permisos.bitDelete);

            if (!permisos.bitOpen) {
                await Swal.fire({
                    title: 'Información',
                    text: 'No tiene los permisos necesarios para acceder a esta opción',
                    icon: 'info',
                    timer: 3000,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    didOpen: () => Swal.showLoading(),
                });
                return;
            }

            const send = {
                Device: data?.FKLokDeviceID,
                Contrato: data?.ContractID,
            };

            const { data: respSet } = await axios.post(
                `${process.env.REACT_APP_SERVER}/operaciones/setlastcontractdevice`,
                send,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    withCredentials: true,
                }
            );

            if (respSet?.success) {
                $('#success-alert')
                    .fadeTo(2000, 500)
                    .slideUp(500, function () {
                        $('#success-alert').slideUp(2000);
                    });
            } else {
                $('#danger-alert')
                    .fadeTo(2000, 500)
                    .slideUp(500, function () {
                        $('#danger-alert').slideUp(2000);
                    });
            }
        } catch (error) {
            console.error('Error en ActualizarContratoDevice:', error);
            $('#danger-alert')
                .fadeTo(2000, 500)
                .slideUp(500, function () {
                    $('#danger-alert').slideUp(2000);
                });
        }
    };

    const EditContrato = async (data) => {
        setDataGlobal(data);

        const payload = { pagina: '18' };

        try {
            const { data: resp } = await axios.post(
                `${process.env.REACT_APP_SERVER}/usuarios/getconfiguracionpagina`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                    withCredentials: true,
                }
            );

            if (resp?.success === false) {
                window.location = '/';
                return;
            }

            const permisos = resp?.data?.[0];
            if (!permisos) return;

            setBitOpenUpdateContract(!!permisos.bitOpen);
            setBitInsertUpdateContract(!!permisos.bitInsert);
            setBitEditUpdateContract(!!permisos.bitEdit);
            setBitDeleteUpdateContract(!!permisos.bitDelete);

            if (permisos.bitOpen) {
                setContratoseleccionado(data?.ContractID ?? null);

                if (data?.trayecto !== 0) {
                    setRutaseleccionada(data.trayecto);
                    setIsDialogOpenAsignacion(true);
                }

                const el = document.getElementById('ModalAsignacion');
                if (el && window.bootstrap?.Modal) {
                    const instance = window.bootstrap.Modal.getOrCreateInstance(el, {
                        backdrop: 'static',
                        keyboard: false,
                    });
                    instance.show();
                }
            } else {
                await Swal.fire({
                    title: 'Información',
                    text: 'No tiene los permisos necesarios para acceder a esta opción',
                    icon: 'info',
                    timer: 3000,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    didOpen: () => Swal.showLoading(),
                });
            }
        } catch (error) {
            console.error('Error al listar bit permisos:', error);
        }
    };

    const handleCloseModalAsignacion = () => {
        if (modalAbierto2) {
            setIsDialogOpenAsignacion(false);
        } else {
            setRutaseleccionada(-1);
        }
    };

    const handleUpdateContract = (ruta) => {
        setRutaseleccionada(ruta);
    };

    const OpenListCheckModal = async () => {
        OpenListCheck(dataGlobal);
    };

    const abrirModal = (data) => {
        setModalAbierto(true);
        setContratoDian(data?.ContractID ?? null);
    };

    const OpenUploadPhoto = async (data) => {
        setDataGlobal(data);

        const payload = { pagina: '15' };

        try {
            const { data: resp } = await axios.post(
                `${process.env.REACT_APP_SERVER}/usuarios/getconfiguracionpagina`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                    withCredentials: true,
                }
            );

            if (resp?.success === false) {
                window.location = '/';
                return;
            }

            const permisos = resp?.data?.[0];
            if (!permisos) return;

            setBitOpenUploadPhoto(!!permisos.bitOpen);
            setBitInsertUploadPhoto(!!permisos.bitInsert);
            setBitEditUploadPhoto(!!permisos.bitEdit);
            setBitDeleteUploadPhoto(!!permisos.bitDelete);

            if (permisos.bitOpen) {
                $('#fotos').val('');
                $('#latitudF').val('0.00');
                $('#longitudF').val('0.00');
                $('#fechafoto').val(
                    utcToPreferredLocalDateTime(data.fecha, { separator: 'T', withSeconds: false }) || data.fecha
                );

                setContratoseleccionado(data.ContractID);
                setUsername(data.username);
                setPlaca(data.PlacaTruck);
                setDevice(data.FKLokDeviceID);
                setFKLokProyecto(data.FKLokProyecto);
                setFKICEmpresa(data.FKICEmpresa);
                setIsDialogOpenModalFoto(true);
            } else {
                await Swal.fire({
                    title: 'Información',
                    text: 'No tiene los permisos necesarios para acceder a esta opción',
                    icon: 'info',
                    timer: 3000,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    didOpen: () => Swal.showLoading(),
                });
            }
        } catch (error) {
            console.error('Error al listar bit permisos:', error);
        }
    };

    const OpenUploadVideo = async (data) => {
        setDataGlobal(data);

        const payload = { pagina: '16' };

        try {
            const { data: resp } = await axios.post(
                `${process.env.REACT_APP_SERVER}/usuarios/getconfiguracionpagina`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                    withCredentials: true,
                }
            );

            if (resp?.success === false) {
                window.location = '/';
                return;
            }

            const permisos = resp?.data?.[0];
            if (!permisos) return;

            setBitOpenUploadVideo(!!permisos.bitOpen);
            setBitInsertUploadVideo(!!permisos.bitInsert);
            setBitEditUploadVideo(!!permisos.bitEdit);
            setBitDeleteUploadVideo(!!permisos.bitDelete);

            if (permisos.bitOpen) {
                $('#videos').val('');
                $('#latitudV').val('0.00');
                $('#longitudV').val('0.00');
                $('#fechaVideo').val(
                    utcToPreferredLocalDateTime(data.fecha, { separator: 'T', withSeconds: false }) || data.fecha
                );

                setContratoseleccionado(data?.ContractID ?? null);
                setUsername(data?.username ?? null);
                setPlaca(data?.PlacaTruck ?? null);
                setDevice(data?.FKLokDeviceID ?? null);
                setFKLokProyecto(data?.FKLokProyecto ?? null);
                setFKICEmpresa(data?.FKICEmpresa ?? null);
                setIsDialogOpenModalVideo(true);
            } else {
                await Swal.fire({
                    title: 'Información',
                    text: 'No tiene los permisos necesarios para acceder a esta opción',
                    icon: 'info',
                    timer: 3000,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    didOpen: () => Swal.showLoading(),
                });
            }
        } catch (error) {
            console.error('Error al listar bit permisos:', error);
        }
    };

    const toggleRow = (contratoId) => {
        setFilteredEquipos((prev) =>
            prev?.map((item) => {
                if (item.ContractID === contratoId) {
                    const newExpandedState = !item.expanded;
                    localStorage.setItem(
                        `contrato_${item.ContractID}_expanded`,
                        JSON.stringify(newExpandedState)
                    );
                    return { ...item, expanded: newExpandedState };
                }
                return item;
            })
        );
    };

    const OpenImages2 = async () => {
        setIsDialogOpenRSeguimientoServicio(false);
        OpenGalleryPhoto(dataGlobal);

        const modalEl = document.getElementById('ModalGaleria');
        if (modalEl && window.bootstrap?.Modal) {
            const modalInstance = window.bootstrap.Modal.getOrCreateInstance(modalEl);
            modalInstance.show();
        }
    };

    const OpenTracking2 = async () => {
        setIsDialogOpenRSeguimientoServicio(false);
        abrirModal2(dataGlobal);

        const modalEl = document.getElementById('ModalReporteSegimiento');
        if (modalEl && window.bootstrap?.Modal) {
            const modalInstance = window.bootstrap.Modal.getOrCreateInstance(modalEl);
            modalInstance.show();
        }
    };

    const OpenReporteConsolidado = async () => {
        OpenModalReporteServicio(dataGlobal);
    };

    const OpenModalReporteServicio = (data) => {
        setInfocontratoAjustado(data);
        setIsDialogOpenModalReporteServicio(true);
    };

    const onCloseModalGaleria = () => {
        setIsDialogOpenModalGaleria(false);
        eliminar();
    };

    const handleModalClose = () => {
        setOnHide(true);
    };

    const cerrarModal = () => {
        setModalAbierto(false);
    };

    const eliminar = () => {
        const elementos = document.getElementsByClassName('object-box');
        const elementosArray = Array.from(elementos);

        elementosArray.forEach((elemento) => {
            if (elemento?.parentNode) {
                elemento.parentNode.removeChild(elemento);
            }
        });
    };

    const OpenTracking = async () => {
        const galeriaEl = document.getElementById('ModalGaleria');
        if (galeriaEl && window.bootstrap?.Modal) {
            const galeriaModal =
                window.bootstrap.Modal.getInstance(galeriaEl) ??
                window.bootstrap.Modal.getOrCreateInstance(galeriaEl);
            galeriaModal.hide();
        } else if (window.$) {
            window.$('#ModalGaleria').modal('hide');
        }

        abrirModal2(dataGlobal);

        const segEl = document.getElementById('ModalReporteSegimiento');
        if (segEl && window.bootstrap?.Modal) {
            const segModal =
                window.bootstrap.Modal.getInstance(segEl) ??
                window.bootstrap.Modal.getOrCreateInstance(segEl);
            segModal.show();
        } else if (window.$) {
            window.$('#ModalReporteSegimiento').modal('show');
        }
    };

    const OpenMonitoreo2 = async () => {
        const galeriaEl = document.getElementById('ModalGaleria');
        if (galeriaEl && window.bootstrap?.Modal) {
            const galeriaModal =
                window.bootstrap.Modal.getInstance(galeriaEl) ??
                window.bootstrap.Modal.getOrCreateInstance(galeriaEl);
            galeriaModal.hide();
        }

        await showModalOpenResporteServicio(dataGlobal);
    };

    const OpenReporteConsolidado2 = async () => {
        OpenModalReporteServicio(dataGlobal);
    };

    const UploadPhoto = async () => {
        const pattern = /\d+\.\d{2,}$/;

        if (!pattern.test($('#latitudF').val()) || !pattern.test($('#longitudF').val())) {
            $('#danger-alert')
                .fadeTo(2000, 500)
                .slideUp(500, function () {
                    $('#danger-alert').slideUp(2000);
                });
            return;
        }

        try {
            const fechaUtc = preferredLocalToUTCDateTime($('#fechafoto').val(), {
                separator: ' ',
                withSeconds: true,
            });
            if (!fechaUtc) {
                $('#danger-alert')
                    .fadeTo(2000, 500)
                    .slideUp(500, function () {
                        $('#danger-alert').slideUp(2000);
                    });
                return;
            }
            const fechacompleta = fechaUtc.replace(/[-: ]/g, '_');

            const files = $('#fotos').prop('files');
            const formData = new FormData();

            for (let i = 0; i < files.length; i++) {
                const baseName = [
                    fechacompleta,
                    i,
                    device ?? '',
                    placa ?? '',
                    eventoseleccionado ?? '',
                    Math.floor(Math.random() * 1000),
                    username ?? '',
                    $('#latitudF').val(),
                    $('#longitudF').val(),
                    contratoseleccionado ?? '',
                    FKLokProyecto ?? '',
                    FKICEmpresa ?? '',
                ].join('_');

                const file = files[i];
                const isImage = file.type.startsWith('image/');
                const isVideo = file.type.startsWith('video/');
                const ext = isImage ? '.jpg' : isVideo ? '.mp4' : '';
                if (!ext) continue;

                formData.append('files', file, baseName + ext);
            }

            await Swal.fire({
                title: 'Subiendo Foto...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });

            const resp = await fetch(`${process.env.REACT_APP_SERVER}/upload`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                },
                body: formData,
            });

            const data = await resp.json();
            Swal.close();

            if (data.hasOwnProperty('success')) {
                $('#success-alert')
                    .fadeTo(2000, 500)
                    .slideUp(500, function () {
                        $('#success-alert').slideUp(2000);
                    });
                $('#ModalFoto .close').click();
            } else {
                $('#danger-alert')
                    .fadeTo(2000, 500)
                    .slideUp(500, function () {
                        $('#danger-alert').slideUp(2000);
                    });
            }
        } catch (err) {
            Swal.close();
            console.error('Error subiendo foto:', err);
            $('#danger-alert')
                .fadeTo(2000, 500)
                .slideUp(500, function () {
                    $('#danger-alert').slideUp(2000);
                });
        }
    };

    const UploadVideo = async () => {
        const pattern = /\d+\.\d{2,}$/;

        if (!pattern.test($('#latitudV').val()) || !pattern.test($('#longitudV').val())) {
            $('#danger-alert')
                .fadeTo(2000, 500)
                .slideUp(500, function () {
                    $('#danger-alert').slideUp(2000);
                });
            return;
        }

        try {
            const fechaUtc = preferredLocalToUTCDateTime($('#fechaVideo').val(), {
                separator: ' ',
                withSeconds: true,
            });
            if (!fechaUtc) {
                $('#danger-alert')
                    .fadeTo(2000, 500)
                    .slideUp(500, function () {
                        $('#danger-alert').slideUp(2000);
                    });
                return;
            }
            const fechacompleta = fechaUtc.replace(/[-: ]/g, '_');

            const files = $('#videos').prop('files');
            if (!files || files.length === 0) {
                $('#danger-alert')
                    .fadeTo(2000, 500)
                    .slideUp(500, function () {
                        $('#danger-alert').slideUp(2000);
                    });
                return;
            }

            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                const file = files[i];

                const newName = [
                    fechacompleta,
                    i,
                    device ?? '',
                    placa ?? '',
                    eventoseleccionado ?? '',
                    Math.floor(Math.random() * 1000),
                    username ?? '',
                    $('#latitudV').val(),
                    $('#longitudV').val(),
                ].join('_');

                if (file.type.startsWith('image/')) {
                    formData.append('files', file, `${newName}.jpg`);
                } else if (file.type.startsWith('video/')) {
                    formData.append('files', file, `${newName}.mp4`);
                }
            }

            await Swal.fire({
                title: 'Subiendo Video...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });

            const resp = await fetch(`${process.env.REACT_APP_SERVER}/uploadvideo`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                },
                body: formData,
            });

            const data = await resp.json();
            Swal.close();

            if (Object.prototype.hasOwnProperty.call(data, 'success')) {
                $('#success-alert')
                    .fadeTo(2000, 500)
                    .slideUp(500, function () {
                        $('#success-alert').slideUp(2000);
                    });
                $('#ModalVideo .close').click();
                $('#videos').val('');
                $('#latitudV').val('0.00');
                $('#longitudV').val('0.00');
            } else {
                $('#danger-alert')
                    .fadeTo(2000, 500)
                    .slideUp(500, function () {
                        $('#danger-alert').slideUp(2000);
                    });
            }
        } catch (err) {
            Swal.close();
            console.error('Error subiendo video:', err);
            $('#danger-alert')
                .fadeTo(2000, 500)
                .slideUp(500, function () {
                    $('#danger-alert').slideUp(2000);
                });
        }
    };

    const showModalOpenResporteServicio = async (data) => {
        const payload = { pagina: '14' };

        try {
            const { data: resp } = await axios.post(
                `${process.env.REACT_APP_SERVER}/usuarios/getconfiguracionpagina`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                    withCredentials: true,
                }
            );

            if (resp?.success === false) {
                window.location = '/';
                return;
            }

            const permisos = resp?.data?.[0];
            if (!permisos) return;

            setBitOpenMonitoreo(!!permisos.bitOpen);
            setBitInsertMonitoreo(!!permisos.bitInsert);
            setBitEditMonitoreo(!!permisos.bitEdit);
            setBitDeleteMonitoreo(!!permisos.bitDelete);

            if (permisos.bitOpen) {
                setDataGlobal(data);
                setContratoseleccionado(data?.ContractID ?? null);
                setIsDialogOpenRSeguimientoServicio(true);
            } else {
                onCloseReporteServicio();
                await Swal.fire({
                    title: 'Información',
                    text: 'No tiene los permisos necesarios para acceder a esta página',
                    icon: 'info',
                    timer: 3000,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    didOpen: () => Swal.showLoading(),
                });
            }
        } catch (error) {
            console.error('Error al listar bit permisos:', error);
        }
    };

    const abrirModal2 = async (data) => {
        setDataGlobal(data);
        setModalIsLoading(true);

        const payload = { pagina: '13' };

        try {
            const { data: resp } = await axios.post(
                `${process.env.REACT_APP_SERVER}/usuarios/getconfiguracionpagina`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                    withCredentials: true,
                }
            );

            if (resp?.success === false) {
                window.location = '/';
                return;
            }

            const permisos = resp?.data?.[0];
            if (!permisos) return;

            setBitOpenTracking(!!permisos.bitOpen);
            setBitInsertTracking(!!permisos.bitInsert);
            setBitEditTracking(!!permisos.bitEdit);
            setBitDeleteTracking(!!permisos.bitDelete);

            if (permisos.bitOpen) {
                setInfocontrato2(data);
                setModalAbierto2(true);
            } else {
                cerrarModal2();
                await Swal.fire({
                    title: 'Información',
                    text: 'No tiene los permisos necesarios para acceder a esta página',
                    icon: 'info',
                    timer: 3000,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
            }
        } catch (error) {
            console.error('Error al listar bit permisos:', error);
        } finally {
            setModalIsLoading(false);
        }
    };

    const abrirModalEnVivo = async (data) => {
        setDataGlobal(data);
        setModalIsLoading(true);

        const payload = { pagina: '13' };

        try {
            const { data: resp } = await axios.post(
                `${process.env.REACT_APP_SERVER}/usuarios/getconfiguracionpagina`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                    withCredentials: true,
                }
            );

            if (resp?.success === false) {
                window.location = '/';
                return;
            }

            const permisos = resp?.data?.[0];
            if (!permisos) return;

            setBitOpenTracking(!!permisos.bitOpen);
            setBitInsertTracking(!!permisos.bitInsert);
            setBitEditTracking(!!permisos.bitEdit);
            setBitDeleteTracking(!!permisos.bitDelete);

            if (permisos.bitOpen) {
                setContratoEnVivo(data);
                setModalEnVivoOpen(true);
                setModalIsLoading(false);
            } else {
                setModalEnVivoOpen(false);
                setContratoEnVivo(null);
                setModalIsLoading(false);
                await Swal.fire({
                    title: 'Información',
                    text: 'No tiene los permisos necesarios para acceder a esta página',
                    icon: 'info',
                    timer: 3000,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
            }
        } catch (error) {
            console.error('Error al listar bit permisos:', error);
        }
    };

    const toggleDropdownMultimedia = () => {
        setDropdownOpenMultimedia(!dropdownOpenMultimedia);
    };

    const toggleDropdownReportes = () => {
        setDropdownOpenReportes(!dropdownOpenReportes);
    };

    const toggleDropdownOpciones = () => {
        setDropdownOpenOpciones(!dropdownOpenOpciones);
    };

    const toggleDropdownValitronics = () => {
        setDropdownOpenValitronics(!dropdownOpenValitronics);
    };

    const renderSortIcon = (column) => {
        if (sortBy === column) {
            if (sortDirection === 'asc') {
                return <span>&uarr;</span>;
            } else {
                return <span>&darr;</span>;
            }
        }

        return null;
    };

    const loadFillData = (array = []) => {
        if (isTrafficLoading) {
            return (
                <tr>
                    <td colSpan="17" className="text-center">
                        <PreloaderHistorico />
                    </td>
                </tr>
            );
        }

        if (!Array.isArray(array) || array.length === 0) {
            return (
                <tr>
                    <td colSpan="16" className="text-center">
                        <i className="bx bxs-spreadsheet bx-lg bx-tada-hover"></i>
                        <p>No se encontraron contratos</p>
                    </td>
                </tr>
            );
        }

        const columnasfijadas = 16;

        return array.map((data, idx) => {
            const key = data?.ContractID ?? data?.FKLokDeviceID ?? idx;
            const anexos = Array.isArray(data?.anexos) ? data.anexos : [];
            const anexos2 = Array.isArray(data?.anexos2) ? data.anexos2 : [];
            const hasAnnex = anexos.length > 0;
            const hasAnnex2 = anexos2.length > 0;

            const iconDesvio = (d) => {
                if (d.FKLokTipoEquipo !== 9 && d.IconDesvio) {
                    return (
                        <img
                            src={d.IconDesvio}
                            width="25"
                            height="25"
                            title="Desvío"
                            alt="Desvío"
                        />
                    );
                } else if (showDesvio && d.FKLokTipoEquipo === 9 && d.DescripcionTrayecto == null) {
                    return (
                        <img
                            src="/images/trayectonull.png"
                            width="25"
                            height="25"
                            title="No tiene georuta asignada"
                            alt="Sin georuta"
                        />
                    );
                } else {
                    return (
                        <img
                            src={d.IconDesvio}
                            width="25"
                            height="25"
                            title="Desvío"
                            alt="Desvío"
                        />
                    );
                }
            };

            const iconGps = (d) => {
                if (d.bitGPS && d.ContadorGps >= 3) {
                    return (
                        <img
                            src="/images/NoGpsAlert.png"
                            width="25"
                            height="25"
                            title={`ultimo(s) ${d.ContadorGps} reporte(s) con GPS invalido(s)`}
                            alt="GPS alerta"
                        />
                    );
                } else if (d.bitGPS) {
                    return (
                        <img
                            src="/images/NoGPS.png"
                            width="25"
                            height="25"
                            title={`ultimo(s) ${d.ContadorGps} reporte(s) con GPS invalido(s)`}
                            alt="GPS inválido"
                        />
                    );
                } else {
                    return <img src="/images/transparent.png" width="25" height="25" alt="" />;
                }
            };

            const tooltipMoving = data?.IconMoving?.includes('stop')
                ? `EL DISPOSITIVO ESTA DETENIDO \n DESDE HACE ${formatMinutesToHoursAndMinutes(
                    data.tiempodetencion
                )}`
                : `EL DISPOSITIVO VA \n A ${data?.Speed ?? 0} KM/H`;

            return (
                <React.Fragment key={key}>
                    <tr
                        onClick={() => toggleRow(data.ContractID)}
                        id={`contract-${data.ContractID}`}
                        className="traficoTR scroll-offset"
                    >
                        {showEmpresa && (
                            <td className="prueba" style={{ color: '#000', paddingLeft: 10 }}>
                                <strong>{data.Ref}</strong>
                            </td>
                        )}
                        {showDispositivo && (
                            <td style={{ color: '#000' }}>{data.PlacaTruck}</td>
                        )}
                        {showUbicacionTrafico && (
                            <td style={{ color: '#000' }}>{data.FKLokDeviceID}</td>
                        )}
                        {showUbicacionTrafico && (
                            <td style={{ color: '#000' }}>{data.ContractID}</td>
                        )}
                        {showUbicacionTrafico && (
                            <td style={{ color: '#000' }}>{data.ContainerNum}</td>
                        )}
                        {showBateria && (
                            <td style={{ textAlign: 'center' }}>
                                <img
                                    src={data.icon_bat}
                                    width="20"
                                    height="25"
                                    title={data.bateria}
                                    alt="Batería"
                                />
                            </td>
                        )}
                        {showRuta && (
                            <td style={{ color: '#000' }}>
                                {formattedGlobalDate(data.LoksysServerTime)}
                            </td>
                        )}
                        {showEstado && (
                            <td style={{ color: '#000' }}>{data.TipoReporte}</td>
                        )}
                        {showUbicacionTrafico && (
                            <td style={{ color: '#000' }}>{data.LastReportNota}</td>
                        )}
                        {showUbicacionGps && (
                            <td style={{ color: '#000' }}>
                                {data.Ciudad}
                                {data.mostrargeocerca === 1 && (
                                    <>
                                        <br />
                                        <strong>Geocerca: </strong>
                                        {data.geocerca} ({data.LastReportgeocerca} min)
                                    </>
                                )}
                            </td>
                        )}
                        {showUbicacionTrafico && (
                            <td style={{ color: '#000' }}>{data.LastReportUbica}</td>
                        )}
                        {showMoving && (
                            <td className="textCenterIcon">
                                <img
                                    src={data.IconMoving}
                                    width="25"
                                    height="25"
                                    title={tooltipMoving}
                                    alt="Movimiento"
                                />
                            </td>
                        )}
                        {showLocked && (
                            <td>
                                <img
                                    src={data.IconLocked}
                                    width="25"
                                    height="25"
                                    title="Estado de apertura"
                                    alt="Apertura"
                                />
                            </td>
                        )}
                        {showNoGps && <td>{iconGps(data)}</td>}
                        {showDesvio && <td>{iconDesvio(data)}</td>}
                        {showBack && (
                            <td>
                                <img
                                    src={data.IconBack}
                                    width="25"
                                    height="25"
                                    title="Retorno"
                                    alt="Retorno"
                                />
                            </td>
                        )}
                        {showSeguro && (
                            <td>
                                <img
                                    src={data.IconSeguro}
                                    width="25"
                                    height="25"
                                    title="Seguridad"
                                    alt="Seguridad"
                                />
                            </td>
                        )}
                        {showValitronics && (
                            <td>
                                <img
                                    src={data.IconValitronics}
                                    width="25"
                                    height="25"
                                    title="Contrato valitronics"
                                    alt="Valitronics"
                                />
                            </td>
                        )}
                        {showTiempo && <td>{data.Tiempo}</td>}
                        <td>
                            <MenuContratos
                                contratoId={data.ContractID}
                                data={data}
                                handleAllStatesDropdowns={handleAllStatesDropdowns}
                                abrirModal2={abrirModal2}
                                abrirModalEnVivo={abrirModalEnVivo}
                                showModalOpenResporteServicio={showModalOpenResporteServicio}
                                toggleDropdownReportes={toggleDropdownReportes}
                                dropdownOpenReportes={dropdownOpenReportes}
                                OpenReporteServicio={OpenReporteServicio}
                                abrirModal={abrirModal}
                                toggleDropdownMultimedia={toggleDropdownMultimedia}
                                dropdownOpenMultimedia={dropdownOpenMultimedia}
                                OpenGalleryPhoto={OpenGalleryPhoto}
                                OpenGalleryVideo={OpenGalleryVideo}
                                OpenUploadPhoto={OpenUploadPhoto}
                                OpenUploadVideo={OpenUploadVideo}
                                toggleDropdownValitronics={toggleDropdownValitronics}
                                dropdownOpenValitronics={dropdownOpenValitronics}
                                OpenComprobante={OpenComprobante}
                                OpenListCheck={OpenListCheckModal}
                                toggleDropdownOpciones={toggleDropdownOpciones}
                                dropdownOpenOpciones={dropdownOpenOpciones}
                                showEditContract={showEditContract}
                                EditContrato={EditContrato}
                                ActualizarContratoDevice={ActualizarContratoDevice}
                            />
                        </td>
                    </tr>

                    {data.expanded && (
                        <>
                            <tr
                                style={{
                                    backgroundColor: '#f5f9ff',
                                    borderBottom: '1px dashed #006699',
                                }}
                            >
                                <td colSpan={columnasfijadas}>
                                    <div className="row">
                                        <div className="col-md-2">
                                            <b>Contrato:</b> {data.ContractID}
                                            <br />
                                            <b>Nivel riesgo:</b>
                                        </div>
                                        <div className="col-md-2">
                                            <b>Ref:</b> {data.Ref}
                                            <br />
                                            <b>Container:</b> {data.ContainerNum}
                                        </div>
                                        <div className="col-md-3">
                                            <b>Trayecto:</b> {data.DescripcionTrayecto}
                                            <br />
                                            <b>Ultimo Contacto:</b>{' '}
                                            {formattedGlobalDate(data.LoksysServerTime)}
                                        </div>
                                        <div className="col-md-5">
                                            <b>Observaciones:</b>
                                            <br />
                                            {data.LastReportNota}
                                        </div>
                                    </div>
                                </td>
                            </tr>

                            {hasAnnex
                                ? anexos.map((anexo) => {
                                    const tt = anexo.IconMoving?.includes('stop')
                                        ? `EL DISPOSITIVO ESTA DETENIDO \n DESDE HACE ${formatMinutesToHoursAndMinutes(
                                            anexo.tiempodetencion
                                        )}`
                                        : `EL DISPOSITIVO VA \n A ${anexo.Speed ?? 0
                                        } KM/H`;
                                    return (
                                        <tr
                                            key={`anexo-${anexo.ContractID}`}
                                            style={{
                                                backgroundColor: '#FFF9C4',
                                                borderBottom: '1px dashed #006699',
                                            }}
                                        >
                                            {showEmpresa && (
                                                <td
                                                    className="prueba"
                                                    style={{
                                                        color: '#000',
                                                        paddingLeft: 5,
                                                    }}
                                                >
                                                    <strong>{anexo.NombreEmpresa}</strong>
                                                </td>
                                            )}
                                            {showDispositivo && (
                                                <td
                                                    style={{
                                                        color: '#000',
                                                        padding: 5,
                                                    }}
                                                >
                                                    {anexo.FKLokDeviceID}
                                                </td>
                                            )}
                                            {showBateria && (
                                                <td
                                                    style={{
                                                        textAlign: 'center',
                                                        padding: 5,
                                                    }}
                                                >
                                                    <img
                                                        src={anexo.icon_bat}
                                                        width="20"
                                                        height="25"
                                                        title={anexo.bateria}
                                                        alt="Batería"
                                                    />
                                                </td>
                                            )}
                                            {showPlaca && (
                                                <td
                                                    style={{
                                                        color: '#000',
                                                        padding: 5,
                                                    }}
                                                >
                                                    {anexo.PlacaTruck}
                                                </td>
                                            )}
                                            {showRuta && (
                                                <td
                                                    style={{
                                                        color: '#000',
                                                        padding: 5,
                                                    }}
                                                >
                                                    {anexo.DescripcionRuta}
                                                </td>
                                            )}
                                            {showEstado && (
                                                <td
                                                    style={{
                                                        color: '#000',
                                                        padding: 5,
                                                    }}
                                                >
                                                    {anexo.TipoReporte}
                                                </td>
                                            )}
                                            {showUbicacionGps && (
                                                <td
                                                    style={{
                                                        color: '#000',
                                                        padding: 5,
                                                    }}
                                                >
                                                    {anexo.Ciudad}
                                                    {anexo.mostrargeocerca === 1 && (
                                                        <>
                                                            <br />
                                                            <strong>Geocerca: </strong>
                                                            {anexo.geocerca} (
                                                            {anexo.LastReportgeocerca} min)
                                                        </>
                                                    )}
                                                </td>
                                            )}
                                            {showUbicacionTrafico && (
                                                <td
                                                    style={{
                                                        color: '#000',
                                                        padding: 5,
                                                    }}
                                                >
                                                    {anexo.LastReportUbica}
                                                </td>
                                            )}
                                            {showMoving && (
                                                <td
                                                    className="textCenterIcon"
                                                    style={{
                                                        padding: 5,
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    <img
                                                        src={anexo.IconMoving}
                                                        width="25"
                                                        height="25"
                                                        title={tt}
                                                        alt="Movimiento"
                                                    />
                                                </td>
                                            )}
                                            {showLocked && (
                                                <td
                                                    style={{
                                                        padding: 5,
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    <img
                                                        src={anexo.IconLocked}
                                                        width="25"
                                                        height="25"
                                                        alt="Apertura"
                                                    />
                                                </td>
                                            )}
                                            {showNoGps && <td>{iconGps(anexo)}</td>}
                                            {showDesvio && <td>{iconDesvio(anexo)}</td>}
                                            {showBack && (
                                                <td>
                                                    <img
                                                        src={anexo.IconBack}
                                                        width="25"
                                                        height="25"
                                                        title="Retorno"
                                                        alt="Retorno"
                                                    />
                                                </td>
                                            )}
                                            {showSeguro && (
                                                <td
                                                    style={{
                                                        padding: 5,
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    <img
                                                        src={anexo.IconSeguro}
                                                        width="25"
                                                        height="25"
                                                        alt="Seguridad"
                                                    />
                                                </td>
                                            )}
                                            {showValitronics && (
                                                <td
                                                    style={{
                                                        padding: 5,
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    <img
                                                        src={anexo.IconValitronics}
                                                        width="25"
                                                        height="25"
                                                        alt="Valitronics"
                                                    />
                                                </td>
                                            )}
                                            {showTiempo && (
                                                <td style={{ padding: 5 }}>
                                                    {anexo.Tiempo}
                                                </td>
                                            )}
                                            <td style={{ padding: 5 }} />
                                        </tr>
                                    );
                                })
                                : hasAnnex2
                                    ? anexos2.map((anexo) => {
                                        const tt = anexo.IconMoving?.includes('stop')
                                            ? `EL DISPOSITIVO ESTA DETENIDO \n DESDE HACE ${formatMinutesToHoursAndMinutes(
                                                anexo.tiempodetencion
                                            )}`
                                            : `EL DISPOSITIVO VA \n A ${anexo.Speed ?? 0
                                            } KM/H`;
                                        return (
                                            <tr
                                                key={`anexo2-${anexo.ContractID}`}
                                                style={{
                                                    backgroundColor: '#A8E6CF',
                                                    borderBottom: '1px dashed #006699',
                                                }}
                                            >
                                                {showEmpresa && (
                                                    <td
                                                        className="prueba"
                                                        style={{
                                                            color: '#000',
                                                            paddingLeft: 5,
                                                        }}
                                                    >
                                                        <strong>{anexo.NombreEmpresa}</strong>
                                                    </td>
                                                )}
                                                {showDispositivo && (
                                                    <td
                                                        style={{
                                                            color: '#000',
                                                            padding: 5,
                                                        }}
                                                    >
                                                        {anexo.FKLokDeviceID}
                                                    </td>
                                                )}
                                                {showBateria && (
                                                    <td
                                                        style={{
                                                            textAlign: 'center',
                                                            padding: 5,
                                                        }}
                                                    >
                                                        <img
                                                            src={anexo.icon_bat}
                                                            width="20"
                                                            height="25"
                                                            title={anexo.bateria}
                                                            alt="Batería"
                                                        />
                                                    </td>
                                                )}
                                                {showPlaca && (
                                                    <td
                                                        style={{
                                                            color: '#000',
                                                            padding: 5,
                                                        }}
                                                    >
                                                        {anexo.PlacaTruck}
                                                    </td>
                                                )}
                                                {showRuta && (
                                                    <td
                                                        style={{
                                                            color: '#000',
                                                            padding: 5,
                                                        }}
                                                    >
                                                        {anexo.DescripcionRuta}
                                                    </td>
                                                )}
                                                {showEstado && (
                                                    <td
                                                        style={{
                                                            color: '#000',
                                                            padding: 5,
                                                        }}
                                                    >
                                                        {anexo.TipoReporte}
                                                    </td>
                                                )}
                                                {showUbicacionGps && (
                                                    <td
                                                        style={{
                                                            color: '#000',
                                                            padding: 5,
                                                        }}
                                                    >
                                                        {anexo.Ciudad}
                                                        {anexo.mostrargeocerca === 1 && (
                                                            <>
                                                                <br />
                                                                <strong>Geocerca: </strong>
                                                                {anexo.geocerca} (
                                                                {anexo.LastReportgeocerca} min)
                                                            </>
                                                        )}
                                                    </td>
                                                )}
                                                {showUbicacionTrafico && (
                                                    <td
                                                        style={{
                                                            color: '#000',
                                                            padding: 5,
                                                        }}
                                                    >
                                                        {anexo.LastReportUbica}
                                                    </td>
                                                )}
                                                {showMoving && (
                                                    <td
                                                        className="textCenterIcon"
                                                        style={{
                                                            padding: 5,
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        <img
                                                            src={anexo.IconMoving}
                                                            width="25"
                                                            height="25"
                                                            title={tt}
                                                            alt="Movimiento"
                                                        />
                                                    </td>
                                                )}
                                                {showLocked && (
                                                    <td
                                                        style={{
                                                            padding: 5,
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        <img
                                                            src={anexo.IconLocked}
                                                            width="25"
                                                            height="25"
                                                            alt="Apertura"
                                                        />
                                                    </td>
                                                )}
                                                {showNoGps && <td>{iconGps(anexo)}</td>}
                                                {showDesvio && <td>{iconDesvio(anexo)}</td>}
                                                {showBack && (
                                                    <td>
                                                        <img
                                                            src={anexo.IconBack}
                                                            width="25"
                                                            height="25"
                                                            title="Retorno"
                                                            alt="Retorno"
                                                        />
                                                    </td>
                                                )}
                                                {showSeguro && (
                                                    <td
                                                        style={{
                                                            padding: 5,
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        <img
                                                            src={anexo.IconSeguro}
                                                            width="25"
                                                            height="25"
                                                            alt="Seguridad"
                                                        />
                                                    </td>
                                                )}
                                                {showValitronics && (
                                                    <td
                                                        style={{
                                                            padding: 5,
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        <img
                                                            src={anexo.IconValitronics}
                                                            width="25"
                                                            height="25"
                                                            alt="Valitronics"
                                                        />
                                                    </td>
                                                )}
                                                {showTiempo && (
                                                    <td style={{ padding: 5 }}>
                                                        {anexo.Tiempo}
                                                    </td>
                                                )}
                                                <td style={{ padding: 5 }} />
                                            </tr>
                                        );
                                    })
                                    : null}
                        </>
                    )}
                </React.Fragment>
            );
        });
    };

    // CARDS RESPONSIVE
    const loadCards = (array = []) => {
        if (isTrafficLoading) {
            return <div className="trafico-oculto-loading"><PreloaderHistorico /></div>;
        }

        if (!Array.isArray(array) || array.length === 0) {
            return (
                <div className="text-center py-4">
                    <i className="bx bxs-spreadsheet bx-lg bx-tada-hover"></i>
                    <p>No se encontraron contratos</p>
                </div>
            );
        }

        return array.map((data, idx) => {
            const key = data?.ContractID ?? data?.FKLokDeviceID ?? idx;

            const tooltipMoving = data?.IconMoving?.includes('stop')
                ? `EL DISPOSITIVO ESTA DETENIDO \n DESDE HACE ${formatMinutesToHoursAndMinutes(
                    data.tiempodetencion
                )}`
                : `EL DISPOSITIVO VA \n A ${data?.Speed ?? 0} KM/H`;

            const iconDesvio = (d) => {
                if (d.FKLokTipoEquipo !== 9 && d.IconDesvio) {
                    return (
                        <img
                            src={d.IconDesvio}
                            width="24"
                            height="24"
                            title="Desvío"
                            alt="Desvío"
                        />
                    );
                } else if (showDesvio && d.FKLokTipoEquipo === 9 && d.DescripcionTrayecto == null) {
                    return (
                        <img
                            src="/images/trayectonull.png"
                            width="24"
                            height="24"
                            title="No tiene georuta asignada"
                            alt="Sin georuta"
                        />
                    );
                } else {
                    return (
                        <img
                            src={d.IconDesvio}
                            width="24"
                            height="24"
                            title="Desvío"
                            alt="Desvío"
                        />
                    );
                }
            };

            const iconGps = (d) => {
                if (d.bitGPS && d.ContadorGps >= 3) {
                    return (
                        <img
                            src="/images/NoGpsAlert.png"
                            width="24"
                            height="24"
                            title={`ultimo(s) ${d.ContadorGps} reporte(s) con GPS invalido(s)`}
                            alt="GPS alerta"
                        />
                    );
                } else if (d.bitGPS) {
                    return (
                        <img
                            src="/images/NoGPS.png"
                            width="24"
                            height="24"
                            title={`ultimo(s) ${d.ContadorGps} reporte(s) con GPS invalido(s)`}
                            alt="GPS inválido"
                        />
                    );
                } else {
                    return <img src="/images/transparent.png" width="24" height="24" alt="" />;
                }
            };

            return (
                <div
                    key={key}
                    className="trafico-card card mb-2"
                    onClick={() => toggleRow(data.ContractID)}
                    style={{
                        padding: 12
                    }}
                >
                    {/* FILA 1: REF + tres puntos a la derecha */}
                    <div className="trafico-card-header d-flex justify-content-between align-items-start w-100 mb-1">
                        <div>
                            <strong>REF:</strong> {data.Ref}
                        </div>

                        {/* Menú (tres puntos) */}
                        <div
                            className="ms-2"
                            onClick={(e) => e.stopPropagation()} // para que no dispare el toggleRow
                        >
                            <MenuContratos
                                contratoId={data.ContractID}
                                data={data}
                                handleAllStatesDropdowns={handleAllStatesDropdowns}
                                abrirModal2={abrirModal2}
                                abrirModalEnVivo={abrirModalEnVivo}
                                showModalOpenResporteServicio={showModalOpenResporteServicio}
                                toggleDropdownReportes={toggleDropdownReportes}
                                dropdownOpenReportes={dropdownOpenReportes}
                                OpenReporteServicio={OpenReporteServicio}
                                abrirModal={abrirModal}
                                toggleDropdownMultimedia={toggleDropdownMultimedia}
                                dropdownOpenMultimedia={dropdownOpenMultimedia}
                                OpenGalleryPhoto={OpenGalleryPhoto}
                                OpenGalleryVideo={OpenGalleryVideo}
                                OpenUploadPhoto={OpenUploadPhoto}
                                OpenUploadVideo={OpenUploadVideo}
                                toggleDropdownValitronics={toggleDropdownValitronics}
                                dropdownOpenValitronics={dropdownOpenValitronics}
                                OpenComprobante={OpenComprobante}
                                OpenListCheck={OpenListCheckModal}
                                toggleDropdownOpciones={toggleDropdownOpciones}
                                dropdownOpenOpciones={dropdownOpenOpciones}
                                showEditContract={showEditContract}
                                EditContrato={EditContrato}
                                ActualizarContratoDevice={ActualizarContratoDevice}
                            />
                        </div>
                    </div>

                    {/* CUERPO: cada item en su propia fila (100% ancho) */}
                    <div className="trafico-card-body">
                        <div className="mb-1">
                            <strong>Contrato:</strong> {data.ContractID}
                        </div>

                        <div className="mb-1">
                            <strong>Container:</strong> {data.ContainerNum}
                        </div>

                        <div className="mb-1">
                            <strong>Placa:</strong> {data.PlacaTruck}
                        </div>

                        <div className="mb-1">
                            <strong>Dispositivo:</strong> {data.FKLokDeviceID}
                        </div>

                        <div className="mb-1">
                            <strong>Último contacto:</strong>{" "}
                            {formattedGlobalDate(data.LoksysServerTime)}
                        </div>

                        <div className="mb-1">
                            <strong>Estado:</strong> {data.TipoReporte}
                        </div>

                        <div className="mb-1">
                            <strong>Obs:</strong> {data.LastReportNota}
                        </div>

                        <div className="mb-1">
                            <strong>Ubicación GPS:</strong> {data.Ciudad}
                            {data.mostrargeocerca === 1 && (
                                <>
                                    {" "}
                                    | <strong>Geocerca:</strong> {data.geocerca} (
                                    {data.LastReportgeocerca} min)
                                </>
                            )}
                        </div>

                        <div className="mb-1">
                            <strong>Ubicación tráfico:</strong> {data.LastReportUbica}
                        </div>
                    </div>

                    {/* ICONOS + TIEMPO en la última fila */}
                    <div className="trafico-card-icons d-flex flex-wrap align-items-center gap-2 mt-2">
                        <div className="trafico-card-icon">
                            <img
                                src={data.icon_bat}
                                width="24"
                                height="24"
                                title={data.bateria}
                                alt="Batería"
                            />
                        </div>

                        <div className="trafico-card-icon">
                            <img
                                src={data.IconMoving}
                                width="24"
                                height="24"
                                title={tooltipMoving}
                                alt="Movimiento"
                            />
                        </div>

                        <div className="trafico-card-icon">
                            <img
                                src={data.IconLocked}
                                width="24"
                                height="24"
                                title="Estado de apertura"
                                alt="Apertura"
                            />
                        </div>

                        <div className="trafico-card-icon">{iconGps(data)}</div>
                        <div className="trafico-card-icon">{iconDesvio(data)}</div>

                        <div className="trafico-card-icon">
                            <img
                                src={data.IconBack}
                                width="24"
                                height="24"
                                title="Retorno"
                                alt="Retorno"
                            />
                        </div>

                        <div className="trafico-card-icon">
                            <img
                                src={data.IconSeguro}
                                width="24"
                                height="24"
                                title="Seguridad"
                                alt="Seguridad"
                            />
                        </div>

                        <div className="trafico-card-icon">
                            <img
                                src={data.IconValitronics}
                                width="24"
                                height="24"
                                title="Contrato valitronics"
                                alt="Valitronics"
                            />
                        </div>

                        <div className="trafico-card-tiempo ms-auto">
                            <strong>{data.Tiempo}</strong>
                        </div>
                    </div>
                </div>


            );
        });
    };

    useEffect(() => {
        listarEquipos();
    }, []);

    useEffect(() => {
        document.body.classList.add('trafico-oculto-responsive-page');
        return () => document.body.classList.remove('trafico-oculto-responsive-page');
    }, []);

    const toggleNavigationMenu = () => {
        document.querySelector('[class*="sidenav-toggle"]')?.click();
    };

    return (
        <>
            <div className="layout-wrapper layout-content-navbar trafico-oculto-page">
                <div className="layout-container">
                    <div className="layout-page">
                        <BarraPrincipal onToggleNavigation={toggleNavigationMenu} />
                        <div className="content-wrapper">
                            <div className="container-fluid flex-grow-1 container-p-y">

                                {/* ===== DESKTOP: TABLA ===== */}
                                <div className="card cardContainerTrafico">
                                    <div
                                        className="table-responsive text-nowrap"
                                        style={{
                                            height: `calc(100vh - 180px)`,
                                            overflowY: "auto",
                                            overflowX: "auto",
                                        }}
                                    >
                                        <table className="table table-hover" id="tablaTRAF">
                                            <thead className="FondoHeaderTabla2">
                                                <tr>
                                                    {showEmpresa && (
                                                        <th style={{ color: "#ffffff", width: "100px" }}>
                                                            REF {renderSortIcon("Referencia")}
                                                        </th>
                                                    )}
                                                    {showDispositivo && (
                                                        <th style={{ color: "#ffffff", width: "100px" }}>
                                                            PLACA {renderSortIcon("Placa")}
                                                        </th>
                                                    )}
                                                    {showBateria && (
                                                        <th style={{ color: "#ffffff", width: "130px" }}>
                                                            DISPOSITIVO {renderSortIcon("Dispositivo")}
                                                        </th>
                                                    )}
                                                    {showPlaca && (
                                                        <th style={{ color: "#ffffff", width: "120px" }}>
                                                            CONTRATO {renderSortIcon("Contrato")}
                                                        </th>
                                                    )}
                                                    {showRuta && (
                                                        <th style={{ color: "#ffffff", width: "110px" }}>
                                                            CONTAINER {renderSortIcon("Container")}
                                                        </th>
                                                    )}
                                                    {showUbicacionGps && (
                                                        <th style={{ color: "#ffffff", width: "70px" }}>
                                                            BATT {renderSortIcon("Bateria")}
                                                        </th>
                                                    )}
                                                    {showUbicacionTrafico && (
                                                        <th style={{ color: "#ffffff", width: "150px" }}>
                                                            ULT. CONTACTO {renderSortIcon("LastReportUbica")}
                                                        </th>
                                                    )}
                                                    {showUbicacionTrafico && (
                                                        <th style={{ color: "#ffffff", width: "100px" }}>
                                                            ESTADO {renderSortIcon("Estado")}
                                                        </th>
                                                    )}
                                                    {showUbicacionTrafico && (
                                                        <th style={{ color: "#ffffff", width: "130px" }}>
                                                            OBSERVACION {renderSortIcon("Observacion")}
                                                        </th>
                                                    )}
                                                    {showUbicacionTrafico && (
                                                        <th style={{ color: "#ffffff", width: "150px" }}>
                                                            UBICACION GPS {renderSortIcon("UbicacionGPS")}
                                                        </th>
                                                    )}
                                                    {showUbicacionTrafico && (
                                                        <th style={{ color: "#ffffff", width: "160px" }}>
                                                            UBICACION TRAFICO {renderSortIcon("UbicacionTrafico")}
                                                        </th>
                                                    )}
                                                    {showMoving && (
                                                        <th style={{ color: "#ffffff", width: "18px" }}>
                                                            {renderSortIcon("IconMoving")}
                                                        </th>
                                                    )}
                                                    {showLocked && (
                                                        <th style={{ color: "#ffffff", width: "18px" }}>
                                                            {renderSortIcon("IconLocked")}
                                                        </th>
                                                    )}
                                                    {showNoGps && (
                                                        <th style={{ color: "#ffffff", width: "18px" }}>
                                                            {renderSortIcon("bitGPS")}
                                                        </th>
                                                    )}
                                                    {showDesvio && (
                                                        <th style={{ color: "#ffffff", width: "18px" }}>
                                                            {renderSortIcon("IconDesvio")}
                                                        </th>
                                                    )}
                                                    {showBack && (
                                                        <th style={{ color: "#ffffff", width: "18px" }}>
                                                            {renderSortIcon("IconBack")}
                                                        </th>
                                                    )}
                                                    {showSeguro && (
                                                        <th style={{ color: "#ffffff", width: "18px" }}>
                                                            {renderSortIcon("IconSeguro")}
                                                        </th>
                                                    )}
                                                    {showValitronics && (
                                                        <th style={{ color: "#ffffff", width: "18px" }}>
                                                            {renderSortIcon("IconValitronics")}
                                                        </th>
                                                    )}
                                                    {showTiempo && (
                                                        <th style={{ color: "#ffffff", width: "100px" }}>
                                                            TIEMPO {renderSortIcon("tiempoUnix")}
                                                        </th>
                                                    )}
                                                    <th style={{ color: "#ffffff", width: "38px" }} />
                                                </tr>
                                            </thead>
                                            <tbody className="table-border-bottom-0" id="tabladata">
                                                {loadFillData(filteredEquipos)}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* ===== MOBILE / TABLET: CARDS ===== */}
                                <div className="card cardContainerTrafico2">
                                    <div
                                        className="trafico-cards-wrapper containerCardsTrafico"
                                        style={{
                                            maxHeight: `calc(100vh - 180px)`,
                                            overflowY: "auto",
                                            padding: "0.5rem",
                                        }}
                                    >
                                        {loadCards(filteredEquipos)}
                                    </div>
                                </div>

                            </div>
                        </div>



                    </div>
                </div>
            </div>

            {/* Modal edición de contrato */}
            <BaseModalCreateSolcitud
                isOpen={isDialogOpenEditSolicitud}
                title="Actualizar contrato"
                onClose={onCloseEditContract}
                childComponent={
                    <FormUpdateContrato
                        contrato={contratoseleccionado}
                        info={infoUpdateContrato}
                        onClose={onCloseEditContract}
                    />
                }
            />

            {/* Modal edición contrato proyecto */}
            <BaseModalCreateSolcitud
                isOpen={isDialogOpenEditContratoProject}
                title="Actualizar contrato"
                onClose={onCloseEditContract}
                childComponent={
                    <FormUpdateContratoProyecto
                        contrato={contratoseleccionado}
                        info={infoUpdateContrato}
                        onClose={onCloseEditContract}
                    />
                }
            />

            {/* Modal seguimiento contrato monitoreo */}
            <RSeguimientoServicio
                isOpen={isDialogOpenRSeguimientoServicio}
                title="Monitoreo de tráfico"
                onClose={onCloseReporteServicio}
                childComponent={
                    <FormReporteServicio
                        contrato={contratoseleccionado}
                        images={OpenImages2}
                        tracking={OpenTracking2}
                        consolidado={OpenReporteConsolidado}
                    />
                }
            />

            {/* Modal Reporte consolidado ajustado */}
            <ModalReporteConsolidadoAjustado
                isOpen={isDialogOpenRServicioAjustado}
                title="Reporte consolidado ajustado"
                onClose={onCloseReporteServicioAjustado}
                childComponent={
                    <FormStaticsMapsRecorrido
                        infoContrato={infocontrato}
                        handleUltPunto={(value) => handleUltPunto(value)}
                        handleUltRecorrido={(value) => handleUltRecorrido(value)}
                        onSubmit={handleSubmitAndOpenReporteAjustado}
                    />
                }
            />

            {/* Modal Reporte servicio */}
            <ModalReporteServicio
                isOpen={isDialogOpenModalReporteServicio}
                onClose={onCloseModalReporteServicio}
                childComponent={
                    <ReporteServicio
                        contrato={infocontratoAjustado}
                        ultPunto={ultPunto}
                        contractR={contractR}
                    />
                }
            />

            {/* Modal Asignación (Bootstrap) */}
            <div
                className="modal fade"
                id="ModalAsignacion"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
            >
                <ModalAsignacion
                    contratoseleccionado={contratoseleccionado}
                    listRutas={listRutas}
                    onClose={handleCloseModalAsignacion}
                    onUpdateContract={handleUpdateContract}
                />
            </div>

            {/* Modal subir fotos */}
            <BaseModalAuto
                isOpen={isDialogOpenModalFoto}
                title="Subir fotos"
                onClose={onCloseModalFoto}
                childComponent={
                    <ModalFoto
                        device={device}
                        username={username}
                        placa={placa}
                        FKICEmpresa={FKICEmpresa}
                        FKLokProyecto={FKLokProyecto}
                        data={dataGlobal}
                        selectedContrato={contratoseleccionado}
                        eventoSeleccionado={eventoseleccionado}
                        listEventos={listEventos}
                        editarEvento={EditarEvento}
                        uploadPhoto={UploadPhoto}
                        onClose={onCloseModalFoto}
                    />
                }
            />

            {/* Modal subir videos */}
            <BaseModalAuto
                isOpen={isDialogOpenModalVideo}
                title="Subir videos"
                onClose={onCloseModalVideo}
                childComponent={
                    <ModalVideo
                        device={device}
                        username={username}
                        placa={placa}
                        FKICEmpresa={FKICEmpresa}
                        FKLokProyecto={FKLokProyecto}
                        data={dataGlobal}
                        selectedContrato={contratoseleccionado}
                        eventoSeleccionado={eventoseleccionado}
                        listEventos={listEventos}
                        onClose={onCloseModalVideo}
                    />
                }
            />

            {/* Modal Galería */}
            <div
                className="modal fade"
                id="ModalGaleria"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
            >
                <ModalGaleria
                    isOpen={isDialogOpenModalGaleria}
                    contratoseleccionado={contratoseleccionado}
                    infocontratoContainer={infocontratoContainer}
                    eliminar={eliminar}
                    onCloseModalGaleria={onCloseModalGaleria}
                    OpenTracking={OpenTracking}
                    OpenMonitoreo2={OpenMonitoreo2}
                    OpenConsolidado={OpenReporteConsolidado2}
                />
            </div>

            {/* Modal Video Galería */}
            <div
                className="modal fade"
                id="ModalVideoGaleria"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
            >
                <div className="modal-dialog modal-lg">
                    <form className="modal-content" id="ModalGaleriaW">
                        <div className="modal-header">
                            <h5 className="modal-title" id="backDropModalTitle">
                                VIDEOS
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={handleModalClose}
                            />
                        </div>
                        <div className="modal-body">
                            <div className="container text-center">
                                <div className="row">
                                    <VideoGallery contrato={contratoseleccionado} />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            {/* Modal Reporte Servicio 2 */}
            <div
                className="modal fade"
                id="ModalReporteServicio"
                data-bs-backdrop="static"
                data-bs-keyboard="true"
                tabIndex="-1"
            >
                <ModalReporteServicio2
                    onCloseModalReporteServicio={onCloseModalReporteServicio}
                    mostrarReporte={mostrarReporteConsolidado}
                    infocontrato={infocontrato}
                    ultPunto={ultPunto}
                    contractR={contractR}
                />
            </div>

            {/* Modal Lista de chequeo */}
            <BaseModalAuto
                size="xl"
                isOpen={isDialogOpenModalListaCheck}
                title=""
                onClose={onCloseModalListaCheck}
                childComponent={<PrintComponent data={infocontrato} />}
            />

            {/* Modal Comprobante Valitronics */}
            <ModalBaseLg
                isOpen={isDialogOpenModalComprobanteValitronics}
                title=""
                onClose={onCloseModalComprobanteValitronics}
                childComponent={
                    <ModalComprobanteValitronics listComprobantes={listComprobantes} />
                }
            />

            {/* Modal Reporte DIAN */}
            <div
                className="modal fade"
                id="ModalReporteDian"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
            >
                <div className="modal-dialog modal-lg">
                    <form className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="backDropModalTitle">
                                Contrato Dian
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <ReporteDian
                                    isOpen={modalAbierto}
                                    onClose={cerrarModal}
                                    contratoVar={contratoDian}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            {/* Modal Contrato Seguimiento (XXL) */}
            <BaseModalXXL
                isOpen={modalAbierto2}
                title="Contrato Seguimiento"
                onClose={cerrarModal2}
                loading={modalLoading}
            >
                <ReporteContrato
                    isOpen={modalAbierto2}
                    onClose={cerrarModal2}
                    contratoVar={infocontrato2}
                    aleatorio={Math.floor(Math.random() * 1000) + 1}
                    images={OpenImages}
                    videos={OpenVideos}
                    valitronics={OpenValitronics}
                    checkList={OpenListCheckModal}
                    monitoreo={OpenMonitoreo}
                    trayecto={showModalTrayecto}
                    consolidado={OpenReporteConsolidado}
                    showEditContract={showEditContract}
                    rutaseleccionadaprop={rutaseleccionada}
                />
            </BaseModalXXL>

            <BaseModalAuto2
                isOpen={modalEnVivoOpen}
                onClose={() => {
                    setModalEnVivoOpen(false);
                    setContratoEnVivo(null);
                    setModalIsLoading(false);
                }}
                size={'xl'}
                title={'En vivo'}
            >
                <EnVivoPanel contrato={contratoEnVivo} />
            </BaseModalAuto2>

            {/* <div className="alert alert-success" id="success-alert">
                <strong>Exitoso! </strong> Los cambios han sido realizados con éxito.
            </div>

            <div className="alert alert-danger" id="danger-alert">
                <strong>Error! </strong> Se ha presentado un error, valide la información.
            </div> */}
        </>
    );
};

export default TraficoOculto;
